import React, { Component } from 'react';

import ScheduledEvents from './ScheduledEvents';
import ModalWrapper from './ModalWrapper';

export default class DisplayRowSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValidOption: true,
    };
  }

  handleChange = (event) => {
    const value = event.target.value;
    const isValid =
      this.props.options && Object.keys(this.props.options).includes(value);
    this.setState({ isValidOption: isValid });
    this.props.handleChange(event);
  };

  handleSave = () => {
    if (!this.state.isValidOption) {
      this.props.handleChange({
        target: {
          name: this.props.id,
          value: this.props.value,
        },
      });
      return;
    }
    this.props.handleSave();
  };

  render() {
    return (
      <tr>
        <td>{this.props.prettyName}</td>
        <td className="detailColumn" onClick={this.props.handleOpen}>
          {this.props.displayValue}
          &nbsp;
          {this.props.layoutDetails ? <a>details</a> : ''}
        </td>
        <ModalWrapper
          show={this.props.edit}
          title={this.props.prettyName}
          handleClose={this.props.handleClose}
          handleSave={this.handleSave}
          handleSchedule={this.props.handleSchedule}
          isSaveDisabled={!this.state.isValidOption}
          layoutDetails={this.props.layoutDetails}
        >
          <div>
            <input
              type="text"
              name={this.props.id}
              value={this.props.value}
              onChange={this.handleChange}
              placeholder="Search..."
              className="form-control"
              list={`${this.props.id}-options`}
              required
            />

            {this.props.options && (
              <datalist id={`${this.props.id}-options`}>
                {Object.keys(this.props.options).map((option, index) => (
                  <option key={index} value={option} />
                ))}
              </datalist>
            )}
            {!this.state.isValidOption && (
              <font className="mandatory">
                Please select a valid option from the dropdown
              </font>
            )}
            <font className="mandatory">{this.props.errorString}</font>
          </div>
          <ScheduledEvents
            events={this.props.events}
            id={this.props.id}
            deleteScheduleAction={this.props.deleteScheduleAction}
            completeScheduleAction={this.props.completeScheduleAction}
            editScheduleAction={this.props.editScheduleAction}
          />
        </ModalWrapper>
      </tr>
    );
  }
}
